var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfileImg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_856_6893)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_856_6893",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.4172,
    cy: 12,
    r: 12,
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_856_6893)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7673 4.54957C32.5187 4.38247 33.2075 5.07132 33.0405 5.82277C31.6393 12.1246 30.8496 20.8827 26.3778 25.3545C21.9061 29.8264 13.1482 30.6162 6.84646 32.0175C6.09503 32.1846 5.40618 31.4957 5.57327 30.7443C6.97446 24.4425 7.76417 15.6843 12.2359 11.2125C16.7076 6.74068 25.4656 5.95086 31.7673 4.54957Z",
    fill: "#E2BBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-13.6477 -4.49408C-13.8148 -5.24551 -13.1259 -5.93436 -12.3745 -5.76728C-6.07267 -4.36611 2.68547 -3.57643 7.15733 0.895249C11.6292 5.36693 12.419 14.1249 13.8203 20.4266C13.9874 21.178 13.2986 21.8668 12.5471 21.6998C6.24531 20.2986 -2.51284 19.5089 -6.98469 15.0372C-11.4565 10.5656 -12.2464 1.8076 -13.6477 -4.49408Z",
    fill: "#FFD6F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6942 12.0495C29.7611 11.7636 30.4058 10.6603 29.9891 9.63734C29.4509 8.31591 28.7371 7.0696 27.8648 5.93285C26.5857 4.26592 24.9908 2.86725 23.1712 1.81669C21.3516 0.766128 19.3428 0.0842573 17.2596 -0.189992C15.839 -0.377014 14.4028 -0.371977 12.9893 -0.177394C11.895 -0.0267634 11.2619 1.08322 11.5478 2.15014L14.6537 13.7411C14.9395 14.808 16.0362 15.4412 17.1031 15.1553L28.6942 12.0495Z",
    fill: "#66B1F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90652 12.234C10.4588 13.1906 11.6958 13.53 12.5475 12.8266C14.4585 11.2485 15.8477 9.10509 16.4976 6.6796C17.3213 3.60548 16.89 0.330041 15.2988 -2.42615C13.7075 -5.18233 11.0865 -7.1935 8.01237 -8.01721C5.58688 -8.66711 3.03607 -8.5358 0.713862 -7.66986C-0.321083 -7.28393 -0.645656 -6.04295 -0.0933765 -5.08638L4.90657 3.5738L9.90652 12.234Z",
    fill: "#267CBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.331655 6.37746C-0.72218 5.98694 -1.35897 5.98445 -1.71564 6.40612C-3.02546 7.95467 -3.9251 9.81462 -4.32291 11.8145C-4.78593 14.1423 -4.54829 16.555 -3.64004 18.7477C-2.73179 20.9404 -1.19371 22.8145 0.77968 24.1331C2.75307 25.4517 5.07315 26.1555 7.44653 26.1555C9.81991 26.1555 12.14 25.4517 14.1134 24.1331C16.0868 22.8145 17.6249 20.9404 18.5331 18.7477C19.4414 16.555 19.679 14.1423 19.216 11.8145C18.8182 9.81462 17.9185 7.95467 16.6087 6.40612C16.252 5.98445 15.6152 5.98694 15.2247 6.37747L8.15364 13.4485C7.76312 13.839 7.12995 13.839 6.73943 13.4485L-0.331655 6.37746Z",
    fill: "#CFE5FF"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_856_6893"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.417236)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImg1);
export default __webpack_public_path__ + "static/media/profileImg1.674129db06cbe58ce1aeb27aec615b34.svg";
export { ForwardRef as ReactComponent };